// extracted by mini-css-extract-plugin
module.exports = {"container":"AccessRestrictedPage__container___3l-HN","card":"AccessRestrictedPage__card___2cqcu","content":"AccessRestrictedPage__content___1gLi7"};